import { useEffect, useState } from "react"
import { getCursos } from '../helpers/GetCategory';

export const usePortfolio = ( category ) => {
  
    const [state, setState] = useState({
        data:[],
        loading: true
    });

    useEffect( () => {
        
        getCursos( category )
            .then( cursos => {
                setState({
                    data: cursos,
                    loading: false
                });
            }) 

    }, [ category ])

    return state;

}


